const FixtureAPIGetUserSubscriptionsEmpty = {
  success: {},
  payload: {
    subscriptions: [],
  },
};
export default FixtureAPIGetUserSubscriptionsEmpty;
